import { render, staticRenderFns } from "./createEditDocument.vue?vue&type=template&id=39746c4d&scoped=true&"
import script from "./createEditDocument.vue?vue&type=script&lang=js&"
export * from "./createEditDocument.vue?vue&type=script&lang=js&"
import style0 from "./createEditDocument.vue?vue&type=style&index=0&id=39746c4d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39746c4d",
  null
  
)

export default component.exports